import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneInternationalDisplay } from '../utils/international-phone';

/**
 * Tenant list/summary phone — same formatting as add/edit {@link IntlPhoneFieldComponent}
 * (+CC + national spacing via {@link formatPhoneInternationalDisplay}).
 */
@Pipe({
  name: 'tenantPhone',
  standalone: true,
})
export class TenantPhonePipe implements PipeTransform {
  transform(
    contactNumber: string | null | undefined,
    countryCode: string | null | undefined,
    countryIso: string | null | undefined = undefined,
  ): string {
    return formatPhoneInternationalDisplay(contactNumber, countryCode, countryIso);
  }
}
